import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import { getLocalStorageItem } from "../../utils/localStorage";
import * as toast from "../../utils/makeToast";
import { useNavigate } from "react-router";
import Download from "../../assets/icons/Download.svg";
import whatsapp from "../../assets/icons/whatsapp.svg";
import email from "../../assets/icons/email.svg";
import styles from "./style.module.css";
import DocUpload from "../DocUpload";
import { useDispatch } from "react-redux";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { services } from "../../utils/services";
import FoemPreview from "../formPreview";
import { accountOpeningSteps } from "../../utils/constants";
import { handleDownload } from "../../utils/helpers";

export interface Ireftype {
  bvn: string;
  refereeFormUrl: string;
  ref2Url: string;
  id: string;
}
function AddRefefAcurrent(props: any) {
  const navigate = useNavigate();
  const [updating, setUpdating] = useState(false);
  const [userDetails, setUserDetails] = useState(
    getLocalStorageItem("userDetails")
  );
  const fileUrl = `${window?.location?.origin}/assets/pdf/Updated_Altbank_Reference_Form.pdf`; // Full URL to PDF
  const formik = useFormik({
    initialValues: {
      bvn: userDetails?.bvn,
      refereeFormUrl: "",
      ref2Url: "",
      id: "0",
    },
    validationSchema: yup.object({
      bvn: yup.string().required("BVN is required"),
      refereeFormUrl: yup.string().url("Invalid URL"),
      // .required("First referral form is required"),
      ref2Url: yup.string().url("Invalid URL"),
      // .required("Second referral form is required"),
      id: yup
        .number()
        .typeError("ID must be a number")
        .integer("ID must be an integer")
        .required("ID is required"),
    }),
    validateOnMount: true,
    onSubmit: (values: Ireftype) => {
      submitValues(values);
    },
  });

  const [isAccountNumberValid, setIsAccountNumberValid] =
    useState<boolean>(false);

  const submitValues = async (values: Ireftype) => {
    if (!values.ref2Url && !values.refereeFormUrl) {
      return handleSkip();
    }
    setUpdating(true);
    const payload = {
      bvn: userDetails?.bvn,
      refereeFormUrl: values?.refereeFormUrl,
      ref2Url: values?.ref2Url,
      id: userDetails?.uploadid,
    };

    const response = await services.CurrentReferee(payload);

    if (response?.isSuccess === true) {
      dispatch(setAccountOpeningStep(accountOpeningSteps.documentUpload));
    } else {
      toast.errorToast("Unable to upload");
    }
    setUpdating(false);
  };

  const dispatch = useDispatch();

  const goToStep = (step: any) => {
    if (step === "update-detail") {
      localStorage.setItem("previous-screen", "document-upload");
    }
    dispatch(setAccountOpeningStep(step));
  };
  const validateEmail = (email) => {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    }
    return false;
  };
  // Function to send via WhatsApp
  const sendViaWhatsApp = () => {
    const message = encodeURIComponent(
      "Here is the reference form. Download it from the link below:\n" + fileUrl
    );
    const whatsappUrl = `https://wa.me/?text=${message}`;
    window.open(whatsappUrl, "_blank");
  };

  // Function to send via Email
  const sendViaEmail = () => {
    const subject = encodeURIComponent("Reference Form");
    const body = encodeURIComponent(
      `Please find the reference form attached.\n\nDownload it here: ${fileUrl}`
    );
    const mailtoUrl = `mailto:?subject=${subject}&body=${body}`;
    window.location.href = mailtoUrl;
  };

  const handleFileAdd = (
    name: keyof Ireftype,
    value: Ireftype[keyof Ireftype]
  ) => {
    formik.setTouched({ [name]: true }, true);
    formik.setFieldValue(name, value);
  };

  const handleSkip = () =>
    dispatch(setAccountOpeningStep(accountOpeningSteps.documentUpload));

  return (
    <div className="px-4">
      <form onSubmit={formik.handleSubmit}>
        <div>
          <div className="p-4">
            <h4 className=" small-bold-texts font-weight-bold text-center mt-1">
              Add Reference
            </h4>
            <div className="card-body mt-4">
              <p style={{ color: "#606062", textAlign: "center" }}>
                Download or email the reference form to refree
                <br /> and upload the completed form. <FoemPreview />
              </p>
            </div>
            <div
              className="mt-5"
              style={{ width: "100%", textAlign: "center" }}
            >
              <p>Share or download</p>
              <div className={styles.iconFlexSvg}>
                <img
                  src={Download}
                  onClick={() =>
                    handleDownload(
                      "/assets/pdf/Updated_Altbank_Reference_Form.pdf",
                      "Reference_Form.pdf"
                    )
                  }
                  alt=""
                />
                <img onClick={sendViaWhatsApp} src={whatsapp} alt="" />
                <img onClick={sendViaEmail} src={email} alt="" />
              </div>
            </div>
          </div>
          <div className="mt-5">
            <DocUpload
              // required
              name="refereeFormUrl"
              show
              label="Upload first referral form"
              getFileUrl={handleFileAdd}
              bottomText="The file format should be JPEG, PNG or PDF  (max size: 2mb)"
              errorMessage={
                formik.touched.refereeFormUrl
                  ? formik.errors.refereeFormUrl
                  : ""
              }
            />
          </div>
          <div className="mt-5 mb-5">
            <DocUpload
              // required
              name="ref2Url"
              show
              label="Upload Second referral form  "
              getFileUrl={handleFileAdd}
              bottomText="The file format should be JPEG, PNG or PDF  (max size: 2mb)"
              errorMessage={formik.touched.ref2Url ? formik.errors.ref2Url : ""}
            />
          </div>
          <div className="d-flex justify-content-end  mt-5">
            <div className="mb-3 mr-4" style={{ marginRight: "20px" }}>
              <button
                onClick={() => {
                  goToStep("update-detail");
                }}
                className="btn btn-outline-gold mr-3 btn-filled-white"
              >
                Previous
              </button>
            </div>
            {updating ? (
              <div className="spinner-border text-gold" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              <button
                // disabled={!formik.isValid}
                type="submit"
                className="btn btn-filled-red"
              >
                Proceed
              </button>
            )}
            {/* <div className="p-2"></div>
            <button
              className="btn btn-outline-gold mr-3 btn-filled-white"
              onClick={handleSkip}
            >
              Skip
            </button> */}
          </div>
        </div>

        {/* ------- */}
      </form>
      {/* ----------- */}

      {/* ----------- */}
    </div>
  );
}

export default AddRefefAcurrent;
